import {
	Checkbox,
	FontIconName,
	Icon
} from "client/Components";
import { ReactElement, useCallback } from "react";
import styles from "./CapabilityCard.module.less";
import { setTrackingId } from "client/Misc/utils";

export type CapabilityCardProps = {
	icon: FontIconName;
	title: string;
	description: string;
	isSelected: boolean;
	onChange: (value: boolean) => void;
	trackingId: string;
};

export const CapabilityCard = (props: CapabilityCardProps): ReactElement => {
	const {
		icon,
		title,
		description,
		isSelected,
		onChange,
		trackingId
	} = props;

	const clickHandler = useCallback(
		(): void => onChange(!isSelected),
		[isSelected, onChange]
	);

	return (
		<div
			{...setTrackingId(trackingId)}
			className={styles.root}
			onClick={clickHandler}
		>
			<div className={styles.header}>
				<div className={styles.iconWrapper}>
					<Icon value={icon} />
				</div>
				<h4 className={styles.title}>
					{title}
				</h4>
				<Checkbox
					value={isSelected}
					onChange={onChange}
					title={title}
					shouldBubbleClick={false}
					trackingId="select"
				/>
			</div>
			<div className={styles.description}>
				{description}
			</div>
		</div>
	);
};
CapabilityCard.displayName = "CapabilityCard";
